









import { Promoted } from '@empathy/search-types';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { SUBMODULES_PATHS } from '../../store';
import { CONFIG_GETTERS_KEYS } from '../../store/config/config.const';

@Component({
  computed: {
    ...mapGetters(SUBMODULES_PATHS.config, {
      components: CONFIG_GETTERS_KEYS.components
    })
  }
})
export default class PromotedComponent extends Vue {
  @Prop({ required: true })
  private item: Promoted;
}
